import type { UserCreateSchema } from '@repo/schemas/user/userCreate';

import { AccountType } from '@repo/types/enums/accountType';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ParentKey } from '#parent/keys';

import { UserKey } from './keys';
import { UserService } from './userService';

export function usePostUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UserCreateSchema) => UserService.createUser(data).then((response) => response.data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [UserKey.USERS] });
      if (variables.accountType === AccountType.Parent) {
        queryClient.invalidateQueries({ queryKey: [ParentKey.PARENTS] });
      }
    },
  });
}
